import { App } from 'vue'
import { handleError } from './errorHandler'
import { isDevelopment } from '@/config/constants'
import { initVConsole } from '@/plugins/vconsole'

export default {
  install(app: App, options: any) {
    if (!isDevelopment) {
      // 错误捕获及处理（非本地环境：内网环境、测试环境及生产环境）
      app.config.errorHandler = (err: any, instance, info) => {
        handleError(err.stack)
      }
    }

    // 插件初始化
    initVConsole()
  }
}